import { defineMessages } from 'react-intl';

export default defineMessages({
  cancel: {
    id: '',
    description: 'button text that closes modal on document password modal',
    defaultMessage: 'Cancel',
  },
  submit: {
    id: '',
    description: 'button text that submits password on document password modal',
    defaultMessage: 'Submit',
  },
  title: {
    id: '',
    description: 'title for document password modal',
    defaultMessage: 'Password required',
  },
  content: {
    id: '',
    description: 'body content for document password modal',
    defaultMessage: 'The document "{ documentName }" is password protected. Please enter the password to continue',
  },
  passwordRequiredError: {
    id: '',
    description: 'Error message if no password is privided',
    defaultMessage: 'Password required',
  },
  wrongPassword: {
    id: '',
    description: 'Error message for wrong password',
    defaultMessage: 'Wrong password, please try again!',
  },
  loadingAltMessage: {
    id: '',
    description: 'Alt text that shows up when the loading spinner gif doesn\'t load',
    defaultMessage: 'Verifying password...',
  },
});
